<template lang="es">
<div class="profile">
    <Navigation></Navigation>

    <div class="container add_top_30 add_bottom_30">
        <div class="row">
			
            <Loader :show="saving" ></Loader>

            <div class="col col-lg-3">
                
                <ProfileSidebar></ProfileSidebar>

            </div>
            
            <div class="col-md-12 col-lg-9" v-if="loading" >
                <Loader :show="loading" type="inline"></Loader>
            </div>

			<div class="col-md-12 col-lg-9" v-if="!loading && purchase" >
                <div class="container box_general">
                    <div class="header_box">
                        <h2><i class="pe-7s-date"></i>Reserva #{{purchase.code}}</h2>
                        <h4>
                            <span class="badge badge-warning" v-if="purchase.status=='AWAITING_PAYMENT'">Pendiente de pago</span>
                            <span class="badge badge-danger" v-if="purchase.status=='FAILED_PAYMENT'">Pago rechazado</span>
                            <span class="badge badge-light" v-if="purchase.status=='REFUNDED_PAYMENT'">Pago devuelto</span>
                            <span class="badge badge-info" v-if="purchase.status=='CONFIRMED'">Pendiente de coordinación</span>
                            <span class="badge badge-success" v-if="purchase.status=='COORDINATED'">Confirmada</span>
                            <span class="badge badge-light" v-if="purchase.status=='DONE'">Realizada</span>
                            <span class="badge badge-danger" v-if="purchase.status=='CANCELLED'">Cancelada</span>
                        </h4>

                    </div>

                    <div class="col-12 mt-3">

                        <div class="alert alert-warning" v-if="payPendingAlertShow">
                            <h4 class="alert-heading">Su exámen se encuetra pendiente de pago. </h4>
                            <!-- Si no realiza el pago antes dentro de las 24 horas posteriores a la solicitud de reserva, se cancelará automáticamente. -->
                            <hr>
                            
                            <Payment :amount="purchase.price" ref="PaymentComponent" @paymentDone="paymentDone" @paymentClosed="paymentClosed"></Payment>
                            
                            <div class="alert-footer">
                                <button class="btn btn-success pull-right" @click="retryPayment">Reintentar pago</button>
                            </div>
                        </div>

                    </div>


                    <div class="row" >
                        
                        <div class="col-md-8" >
                            <div class="book-data" >
                                <div class="box">
                                    <div class="subtitle">EXÁMEN</div>
                                    <div class="value">
                                        <small class="text-secondary">{{purchase.service.service.category.name }}</small><br>
                                        {{purchase.service.service.name }}
                                    </div>
                                </div>
                                <!-- <div class="box">
                                    <div class="subtitle">FECHA Y HORA</div>
                                    <div class="value">
                                        <div class="date">{{booking.timeslot.datetime | moment("dddd DD [de] MMMM HH:mm")}}</div>
                                    </div>
                                </div> -->
                                
                                <div class="box" v-if="purchase.status=='COORDINATED' || purchase.status=='DONE'">
                                    <div class="subtitle">COORDINADO PARA</div>
                                    <div class="value">
                                        <div class="date">{{purchase.coordinatedTo | moment("dddd DD [de] MMMM HH:mm")}}</div>
                                    </div>
                                    <p>{{purchase.coordinatedComments}}</p>
                                </div>

                                <div class="box">
                                    <div class="subtitle">UBICACIÓN</div>
                                    <div class="value">
                                        <span v-if="purchase.status == 'CONFIRMED'" >{{purchase.address.street}} {{purchase.address.number}} <br></span>
                                        <small> {{purchase.address.locality.name}}, {{purchase.address.locality.region.name}} </small>
                                    </div>
                                </div>

                                <div class="box">
                                    <div class="subtitle">Costo del exámen</div>
                                    <div class="value">
                                        $ {{purchase.price}}
                                    </div>
                                </div>
                                <!-- <div class="box" v-if="booking.comments">
                                    <div class="subtitle">HISTORIA</div>
                                    <div class="value">
                                        <p>{{booking.comments}}</p>
                                    </div>
                                </div> -->

                                <div class="box" v-if="purchase.status=='DONE'">
                                    <div class="subtitle">Archivos adjuntos</div>
                                    <div class="value">
                                        <FileList :files="purchase.files" size="xs"></FileList>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div class="col-md-4">
                            <div class="medic-info">
                                <figure class="mb-3">
                                    <div class="avatar" v-if="purchase.clinic.picture" :style="'background-image:url('+API_URL+purchase.clinic.picture.url+')'"></div>
                                    <div class="avatar" v-if="!purchase.clinic.picture" :style="'background-image:url('+require('@/assets/img/no-avatar-image.gif')+')'"></div>
                                </figure>
                                
                                <h1>{{purchase.clinic.name}}</h1>

                                <div class="especialities">
                                    <small  v-for="service in purchase.clinic.services" :key="service.id">
                                        {{service.service.name}} <br>
                                    </small>
                                </div>
                                
                            </div>
                        </div>

                        <div class="col-12" v-if="purchase.payments.length>0">
                            <div class="book-data" >
                                <div class="box">
                                    <div class="subtitle">PAGOS</div>

                                    <ul class="payments">
                                        <li v-for="payment in purchase.payments" :key="payment.pw_purchase_id">
                                            <div class="brand-logo" v-if="payment.pay_method">
                                                <img :src="require(`@/assets/img/icon-payment-${payment.pay_method.toLowerCase()}.png`)" class="img-fluid">
                                            </div>
                                            <div class="content">
                                                <h2 v-if="payment.card_last_numbers">Tarjeta terminada en {{payment.card_last_numbers}}</h2>
                                                <h2 v-else>Cupón de pago</h2>
                                                <h3>
                                                    #{{payment.pw_purchase_id}} - 
                                                    <span v-if="payment.pw_transaction_status==1" class="text-success">Pago aprobado</span>
                                                    <span v-if="payment.pw_transaction_status==2" class="text-warning">Pago pendiente</span>
                                                    <span v-if="payment.pw_transaction_status==3" class="text-warning">Pago pre-autorizado</span>
                                                    <span v-if="payment.pw_transaction_status==4" class="text-danger">Pago rechazado</span>
                                                </h3>
                                            </div>
                                            <div class="date">
                                                {{payment.created_at | moment('DD/MM/YY HH:mm:ss')}}
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12" >
                            
                            <div v-if="!payPendingAlertShow && purchase.userCanRetryPay" >
                                <p>
                                    <button class="btn btn-success pull-right" @click="payPendingAlertShow =true">Reintentar con otro medio de pago</button>
                                </p>
                            </div>
                        </div>

                        <hr>

                        <div class="col-12 mt-4">
                            <router-link tag="button" class="btn btn-sm pull-left" to="/clinic-services">Volver</router-link>
                        </div>
                    </div>


                </div>

            </div>

        </div>
        
    </div>
    

    <!-- <BookingPreview ref="BookingPreview"></BookingPreview> -->

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import Navigation from '@/components/Navigation';
import ProfileSidebar from '@/components/ProfileSidebar';
import Footer from '@/components/Footer';
import Loader from '@/components/Loader';
import Payment from '@/components/Payment';
import FileList from '@/components/FileList';

export default {
    name: 'clinicServiceDetail',
    metaInfo() {
        return{
            title: 'Compra # ' + this.purchase.code,
        }
	},
    components: {
        Navigation,
        Footer,
        Loader,
        ProfileSidebar,
        Payment,
        FileList,
    },
    data() {
        return {
            action: this.$route.query.action,
            loading:true,
            saving:false,
            purchase:{},
            previewPane:{
				show: false,
				data: {
					id:''
				}
            },
            API_URL: process.env.VUE_APP_API_URL,
            payPendingAlertShow: false,
            now: this.$moment().format('YYYY-MM-DD HH:mm:ss')
        }
	},
	computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
	methods:{
        
        retryPayment(){
            this.saving=true;
            let paymentValidate = this.$refs.PaymentComponent.validate()

            if (paymentValidate.valid) {
                this.$refs.PaymentComponent.proccess(this.purchase,'clinicService');
            } else {
                this.saving=false;
                this.$toast.error(paymentValidate.err);
            }
        },
        paymentDone(purchaseCode,data){
            if (!purchaseCode) {
                alert(data)
                this.saving = false
            }else{
                console.log('PaymentDone',purchaseCode,data)
                this.$router.push(`/service-checkout/${purchaseCode}/payment`);
            }
        },
        paymentClosed (paying) {
            console.log('paymentClosed on  detail',paying)
            if(!paying){
                this.saving = false
            }
        },
        bookingRefund(){
			this.$dialog
            .confirm({
                title:'Solicitar devolución',
                body: '¿Estás seguro que no deséas reagendar tu consulta y solicitar la devolución del dinero?',
            })
            .then( () => {
                if( !this.saving && this.booking.id > 0 ){
                    this.saving=true;

                    this.$apollo.mutate({
                        mutation: gql`mutation ( $id:ID! ){
                            bookingCancelByUser( id: $id ) {
                                id
                                status
                            }
                        }`,
                        variables: {
                            id: this.booking.id,
                        }
                    })
                    .then(() => {
                        this.$apollo.queries.booking.refetch();
                        this.$toast.success('Devlución solicitada');
                        
                        this.saving=false;
                    })
                    .catch( () => {
                        this.$toast.error('Oops!');
                        this.saving=false;
                    })
                }
            })
            .catch( () => {
                console.log('Clicked on cancel');
                this.saving=false;
            });			
        },
        bookingCancel(){
			this.$dialog
            .confirm({
                title:'Cancelar consulta',
                body: 'Estás seguro que deseás CANCELAR ESTA RESERVA? <br>TU DINERO SERÁ DEVUELTO y podrás agendar con otro especialista.',
            })
            .then( () => {
                if( !this.saving && this.booking.id > 0 ){
                    this.saving=true;

                    this.$apollo.mutate({
                        mutation: gql`mutation ( $id:ID! ){
                            bookingCancelByUser( id: $id ) {
                                id
                                status
                            }
                        }`,
                        variables: {
                            id: this.booking.id,
                        }
                    })
                    .then(() => {
                        this.$apollo.queries.booking.refetch();
                        this.$toast.success('Consulta cancelada');
                        
                        this.$router.push('/doctors/' + this.booking.medicEspeciality.especiality.slug);
                        this.saving=false;
                    })
                    .catch( () => {
                        this.$toast.error('Oops!');
                        this.saving=false;
                    })
                }
            })
            .catch( () => {
                console.log('Clicked on cancel');
                this.saving=false;
            });			
        },
        
    },
    apollo: {
        me: {
            query: gql`query ($id:ID!){
                me{
                    clinic_service(id:$id) {
                        id
                        code
                        price
                        status
                        coordinatedTo
                        coordinatedComments
                        user{
                            email
                            doc_type
                            doc_number
                        }
                        service{
                            service{
                                name
                                category{ name }
                            }
                        }
                        clinic{
                            id
                            name
                            picture{
                                url
                            }
                            services{
                                service{
                                    name
                                }
                            }
                        }
                        payments{
                            currency
                            amount
                            pw_purchase_id
                            pw_transaction_status
                            pay_method
                            card_last_numbers
                            created_at
                        }
                        address{
                            street
                            number
                            locality{
                                name
                                region{
                                    name
                                }
                            }
                        }
                        files{
                            id
                            filename
                            extension
                            type
                            url
                            urlThumb
                        }
                        # is_donated
                        # userCanCancel
                        # userCanPay
                        userCanRetryPay
                    }
                }
            }`,
            fetchPolicy: 'no-cache',
            variables(){
                return {
                    id: this.$route.params.id,
                }
            },
            result (data) {
                //si la reserva fue cancelada pr el medico Y tiene el flag de reagendar, abro directamente la reangenda.
                
                this.purchase = data.data.me.clinic_service[0];
                if(!this.purchase){
                    this.$router.push('/clinic-services');
                }
                
                this.payPendingAlertShow = (this.purchase.status=='FAILED_PAYMENT' && this.purchase.userCanRetryPay) || 
                                            (this.purchase.status=='AWAITING_PAYMENT' && this.purchase.userCanRetryPay && this.purchase.payments.length==0);
                this.loading=false;
            },
        }
    },
    
	
}
</script>

<style scoped>

.book-data{
    width: 100%;
}
.book-data .box{
    padding: 12px 8px;
}
.book-data .box:not(:last-child){
    border-bottom:solid 1px #ededed;
}
.book-data .box .subtitle{
    font-size: 12px;
    text-transform: uppercase;
    color: #666;
}
.book-data .box .value{
    font-size: 18px;
    text-transform: capitalize;
    line-height: 18px;
}
.book-data .box .value p{
    font-size: 14px;
    text-transform: none;
    line-height: 14px;
}

.medic-info{
    border-left: solid 1px #ededed;
    padding: 18px;
    text-align: center;
}
.medic-info figure {
    width:90px;
    margin: auto;
    border-radius: 45px;
    overflow: hidden;
}

.medic-info .rating {
    margin-bottom: 20px;
    display: inline-block;
}

.medic-info small {
    text-transform: uppercase;
    color: #999;
    font-weight: 600;
}

.medic-info h1 {
    font-size: 18px;
}


.actions-box{
    border-top: 1px solid #ededed;
    width: 100%;
    padding: 12px 8px;
}


.payments{
}
.payments li{
    width: 100%;
    padding: 8px;
    border-bottom: solid 1px #ededed;
    display: flex;
    align-items: center;
}
.payments .brand-logo{
    margin-right: 8px;
    max-width: 120px;
}

.payments h2{
    font-size: 14px;
    font-weight: 600;
    margin: 0px;
}
.payments h3{
    font-size: 14px;
    font-weight: 400;
    margin: 0px;
    color: #666;
}
.payments h3 span{
    font-weight: 400;
}
.payments .date{
    flex-grow: 1;
    text-align: right;
    color: #999;
    font-size: 12px;
}
</style>
